import { IDocuments } from '../../types';
import { BRPCalculation } from './BRP-calculation';
import { addTime } from './helpers/addTime';
import { getVisaMetadata } from './helpers/getVisaMetadata';
import { isStudentVisaCalculationAllowed } from './helpers/isStudentVisaCalculationAllowed';

export const getT4VisaTime = (documents: IDocuments | undefined): number => {
  let totalTime = 0;
  if (!documents || !documents.studentVisas) {
    return totalTime; // skip calculation
  }

  Object.values(documents.studentVisas).forEach(visa => {
    const metadata = getVisaMetadata(visa);
    if (!isStudentVisaCalculationAllowed(metadata)) {
      return; // skip calculation
    }

    const BRPCheckResponse = BRPCalculation(visa.biometric, visa.visa, metadata.shortenedDate);

    if (BRPCheckResponse) {
      totalTime = addTime(totalTime, BRPCheckResponse);
      return;
    }

    Object.values(visa.visa ?? {}).forEach(studentVisa => {
      if (studentVisa.startDate) {
        if (metadata.isVisaShortened && metadata.shortenedDate) {
          totalTime = addTime(totalTime, {
            startDate: studentVisa.startDate,
            endDate: metadata.shortenedDate,
          });
        } else if (studentVisa.endDate) {
          totalTime = addTime(totalTime, {
            startDate: studentVisa.startDate,
            endDate: studentVisa.endDate,
          });
        }
      }
    });
  });

  return totalTime;
};
